module.exports = __webpack_public_path__ + "de77a722/img/delete-icon.eb7de062.svg";